import { Component } from '@angular/core';
import { TranslationsComponent } from '../../translations/translations.component';

@Component({
    selector: 'app-home',
    standalone: true,
    imports: [TranslationsComponent],
    templateUrl: './home.component.html',
    styleUrl: './home.component.css'
})
export class HomeComponent { }
